import { Form, Modal, Select, notification } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import {
  getInstructors,
  selectAssignableInstructors,
} from "store/slices/instructorsSlice";
import {
  getSupportCourse,
  updateSupportCourse,
} from "store/slices/supportCoursesSlice";

const AssignSupportCourseInstructorModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form?.useForm();

  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { supportCourse, loading } = useSelector(
    (state) => state?.supportCourses
  );
  const instructors = useSelector(selectAssignableInstructors);

  const open =
    isModalOpen && modalType === "assign_support_course_instructor";
  const supportCourseId = modalProps?.supportCourseId;

  useEffect(() => {
    if (!open) {
      return;
    }

    dispatch(getInstructors());

    if (!supportCourse || supportCourse?._id !== supportCourseId) {
      dispatch(getSupportCourse(supportCourseId));
    } else {
      form?.setFieldsValue({
        instructorId: supportCourse?.instructor?._id,
      });
    }
  }, [dispatch, open, supportCourseId, supportCourse, form]);

  useEffect(() => {
    if (!open || !supportCourse) {
      return;
    }

    form?.setFieldsValue({
      instructorId: supportCourse?.instructor?._id,
    });
  }, [form, open, supportCourse]);

  const handleClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  const handleSubmit = async ({ instructorId }) => {
    if (!supportCourseId || !instructorId) {
      return;
    }

    try {
      const formData = new FormData();
      formData?.append("instructorId", instructorId);

      await dispatch(
        updateSupportCourse({
          id: supportCourseId,
          data: formData,
        })
      )?.unwrap();

      await dispatch(getSupportCourse(supportCourseId))?.unwrap();

      notification?.success({
        message: t("supportCourse.instructor.success"),
      });

      handleClose();
    } catch (error) {
      notification?.error({
        message: t("supportCourse.instructor.error"),
        description: error?.message || t("common.error.generic"),
      });
    }
  };

  return (
    <Modal
      title={t("supportCourse.instructor.manage")}
      open={open}
      onCancel={handleClose}
      onOk={() => form?.submit()}
      confirmLoading={loading}
      destroyOnClose
      centered
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="instructorId"
          label={t("instructors.crud.form.label.name")}
          rules={[
            {
              required: true,
              message: t("supportCourse.form.error.instructor"),
            },
          ]}
        >
          <Select
            placeholder={t("supportCourse.instructor.select")}
            loading={loading}
            showSearch
            optionFilterProp="children"
          >
            {instructors?.map((instructor) => (
              <Select.Option key={instructor?._id} value={instructor?._id}>
                {instructor?.fullName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AssignSupportCourseInstructorModal;
